import { render, staticRenderFns } from "./SaveText.vue?vue&type=template&id=0af180d6&"
import script from "./SaveText.vue?vue&type=script&lang=js&"
export * from "./SaveText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports